module.exports = __webpack_public_path__ + "static/media/bg1.7a016d5d.gif";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_136/imgs/bg1.gif
// module id = 1216
// module chunks = 0